import { Mail, MessageSquareText, Phone } from "lucide-react";
import { EMAIL, PHONE, PHONE_RAW, scrollToId } from "./shared";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="border-t border-stone-800 bg-[#090807] px-4 pb-12 pt-20 sm:px-8">
      <div className="mx-auto max-w-7xl">
        <button
          data-testid="footer-wordmark"
          onClick={() => scrollToId("top")}
          className="block text-left font-display text-5xl font-black uppercase leading-[0.9] tracking-tight text-bone transition-colors duration-200 hover:text-amber-500 sm:text-7xl"
        >
          Friday<span className="text-amber-500">Stumps</span>.com
        </button>

        <p className="mt-6 max-w-md font-mono text-xs leading-relaxed tracking-[0.1em] text-stone-500">
          Eric Fisher — owner-operator. Hand-ground across Central Ohio, one
          Friday at a time.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <a data-testid="footer-call-link" href={`tel:${PHONE_RAW}`} className="flex items-center gap-2 border border-stone-700 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-200 transition-colors duration-150 hover:border-amber-500 hover:text-amber-500">
            <Phone className="h-3.5 w-3.5" /> {PHONE}
          </a>
          <a data-testid="footer-sms-link" href={`sms:${PHONE_RAW}`} className="flex items-center gap-2 border border-stone-700 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-200 transition-colors duration-150 hover:border-amber-500 hover:text-amber-500">
            <MessageSquareText className="h-3.5 w-3.5" /> Text a photo
          </a>
          <a data-testid="footer-email-link" href={`mailto:${EMAIL}`} className="flex items-center gap-2 border border-stone-700 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-200 transition-colors duration-150 hover:border-amber-500 hover:text-amber-500">
            <Mail className="h-3.5 w-3.5" /> {EMAIL}
          </a>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-4 border-t border-stone-800/70 pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-600 sm:flex-row">
          <span>© {new Date().getFullYear()} FridayStumps.com · Columbus, OH</span>
          <span className="flex items-center gap-4">
            <span>Fridays only · 100% contactless · priced by the inch</span>
            <a href="/inbox" data-testid="footer-owner-link" className="text-stone-500 transition-colors duration-150 hover:text-amber-500">
              Owner
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
